
export enum tableNames
{
    Servers = 'servers',
    Users = 'users',
    Devices = 'devices',
    CentralNumber = 'central-number',
    AdminNumber = 'admin-number',
}

export interface tableServer
{
    id: number;
    url: string;
}

export interface tableUser
{
    id: number;
    email: string;
    password: string;
    data: string;
}

export interface tableDevice
{
    id: number;
    mobile: string;
    carName: string;
    deviceId: string;
    imei: string;
    deviceType: string;
    selected: number;

    concoxActiveSystem: any;
    concoxInactiveSystem: any;
    concoxCurrentLocation: any;
    concoxTurnOff: any;
    concoxAlarmSpeed: any;
    concoxAlarmDisconnectBattery: any;
    concoxAlarmDoor: any;
    concoxAlarmImpact: any;
    concoxAlarmMoving: any;
    concoxAlarmTurnOn: any;
    concoxAlarmTurnOff: any;
    concoxResetDevice: any;
    concoxCentralNumber: any;
    concoxDeviceAdmin: any;
    cobanActiveSystem: any;
    cobanInactiveSystem: any;
    cobanActiveListen: any;
    cobanInactiveListen: any;
    cobanTurnOff: any;
    cobanAlarmSpeed: any;
    cobanAlarmMoving: any;
    cobanAlarmTurnOn: any;
    cobanAlarmSOS: any;
    cobanResetDevice: any;
    cobanPointDistance: any;
    cobanDeviceAdmin: any;

    deviceAdminMobile1: any;
    deviceAdminMobile2: any;
    deviceAdminMobile3: any;

    centralNumberMobile1: any;
    centralNumberMobile2: any;
    centralNumberMobile3: any;

    distanceMinute: any;
    distanceSecond: any;
}

export interface tableCentralNumber
{
    id: number;
    mobile: string;
}

export interface tableAdminNumber
{
    id: number;
    mobile: string;
}
